module.exports = __webpack_public_path__ + "img/11825385_L.09249924.png";